var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircularBackEnabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_216",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "go_back",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_216-2",
    "data-name": "Rectangle 216",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "#bfbfbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 49.5,
    height: 49.5,
    rx: 24.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "left_back",
    d: "M97.462,9.891l6.789,7.739a1.012,1.012,0,0,0,1.564,0,1.389,1.389,0,0,0,0-1.782L99.808,9l6.007-6.848a1.389,1.389,0,0,0,0-1.783,1.012,1.012,0,0,0-1.564,0l-6.789,7.74a1.388,1.388,0,0,0,0,1.782Z",
    transform: "translate(-76.639 16)",
    fill: "#10374e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularBackEnabled);
export default __webpack_public_path__ + "static/media/circular_back_enabled.e86877c5f675860e629405cd33c28f8a.svg";
export { ForwardRef as ReactComponent };